import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusList, sendBonus, userList } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      userList: [],
      bonusTag: 0,
      bonusList: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    configBonusList({}).then(function _callee(res) {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.bonusList = res;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  methods: {
    clickImport: function clickImport() {
      this.$refs.import.value = null; //解决change事件在同一个文件下不触发的问题

      this.$refs.import.click();
    },
    clickDownTemplate: function clickDownTemplate() {
      var title = '奖金发放表模板';
      var columns = [{
        label: '会员编号',
        prop: 'number'
      }, {
        label: '发放奖金',
        prop: 'bonus'
      }];
      this.$export.excel({
        columns: columns,
        data: [],
        size: 'mini',
        title: title
      }).then(function () {});
    },
    onExcelImport: function onExcelImport(event) {
      var _this2 = this;

      var file = event.target.files[0];
      this.$import.xlsx(file).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;

        if (results.length === 0) {
          return;
        }

        var item = results[0];

        if (!item.hasOwnProperty('会员编号') || !item.hasOwnProperty('发放奖金')) {
          _this2.$message({
            message: '表格字段错误，请先下载导入模板',
            type: 'error'
          });

          return;
        }

        var tmp = [];

        for (var i in results) {
          tmp.push({
            number: results[i]['会员编号'],
            bonus: results[i]['发放奖金']
          });
        }

        _this2.userList = tmp;
      }); // 阻止默认的上传

      return false;
    },
    bonusTotal: function bonusTotal() {
      var total = 0;

      for (var i in this.userList) {
        total += this.userList[i].bonus;
      }

      return total;
    },
    clickSend: function clickSend() {
      var _this3 = this;

      var dicNumber = {};

      for (var i in this.userList) {
        var number = this.userList[i].number;

        if (dicNumber.hasOwnProperty(number)) {
          this.$alert('数据中有重复的会员编号，请校验是否正确' + number, '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });
          return;
        }

        dicNumber[number] = 1;
      }

      this.$prompt('确定现在发放奖金么？请输入发放备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入备注信息'
      }).then(function (_ref2) {
        var value = _ref2.value;

        _this3.$g.fun.startLoading('发放中......');

        sendBonus({
          remark: value,
          bonus_tag: _this3.bonusTag,
          data: _this3.userList
        }).then(function _callee2(res) {
          return regeneratorRuntime.async(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this3.$g.fun.endLoading();

                  _this3.$alert('发放成功', '奖金发放', {
                    confirmButtonText: '确定',
                    callback: function callback(action) {}
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          });
        }).catch(function (error) {
          _this3.$g.fun.endLoading();
        });
      });
    }
  }
};